export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span>连载漫画追更平台</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight mb-4">
              UU漫画 · 漫画追更
              <br className="hidden sm:block" />
              最新漫画更新一站掌握
            </h1>

            <p className="text-lg md:text-xl text-foreground-500 font-medium mb-5">
              追漫必备，更新提醒永不错过
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              UU漫画专注连载漫画的同步追更服务，覆盖热血、恋爱、悬疑、奇幻等全品类最新漫画更新。
              智能更新提醒让你第一时间知晓连载漫画最新章节，免费漫画全集随时打开即看。
              无论是周更、月更还是不定时更新，追更漫画从此不再遗漏任何一话。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mb-8">
              {[
                { value: '12,000+', label: '收录漫画' },
                { value: '每日更新', label: '更新频率' },
                { value: '30+', label: '覆盖品类' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="font-heading text-2xl md:text-3xl font-black text-primary-500">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-bar-chart-line"></i>
                查看追更榜单
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-secondary-100 text-foreground-700 font-semibold rounded-full hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-compass-3-line"></i>
                浏览漫画索引
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] overflow-hidden rounded-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20a%20modern%20manga%20reading%20experience%20with%20floating%20comic%20pages%20and%20dynamic%20motion%20lines%2C%20warm%20orange%20and%20red%20accents%20on%20a%20soft%20cream%20background%2C%20clean%20minimalist%20composition%20with%20Japanese%20manga%20aesthetic%2C%20editorial%20illustration%20style%20with%20bold%20graphic%20elements%20and%20negative%20space&width=960&height=720&seq=hero-manga-2026&orientation=landscape"
                alt="UU漫画追更平台主视觉 - 漫画阅读体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}